import React, {useEffect, useRef, useState} from 'react';
import {Button, Col, FormControl, InputGroup, Modal, Radio, Row} from 'react-bootstrap';
import ColorCheckbox from '../../../Scheduler/ColorCheckbox';
import './JSAModal.scss';
import _ from 'lodash';
import {defaultDateFormat, mapForSelect, select} from '../../../../common/commonHandlers';
import moment from 'moment-timezone';
import Datetime from 'react-datetime';
import Select from "react-select";

const answers_type = [
    {label: 'Answer', value: 'answer'},
    {label: 'Yes or No (Yes)', value: 'yes_section'},
    {label: 'Yes or No (No)', value: 'no_section'},
    {label: 'Text Answer', value: 'text_answer'},
    {label: 'Work Plan', value: 'work_plan'}
]

const JSAModal = ({onHide, onSave, serviceType, workOrderId, savedForm, isEdit = true, onReload, serviceTypeList, onServiceChange}) => {
    const [editing, setEditing] = useState(null);
    const [forms, setForms] = useState(savedForm || []);
    const [selectedService, setSelectedService] = useState(serviceTypeList && serviceTypeList[0].id);
    const [formIndex, setFormIndex] = useState(0);
    const modalScrollRef = useRef(null);

    const handlePrevious = () => {
        setFormIndex(prevIndex => Math.max(0, prevIndex - 1));
    };

    const handleNext = () => {
        setFormIndex(prevIndex => Math.min(forms.length - 1, prevIndex + 1));
    };

    useEffect(() => {
        if (editing?.delete) {
            handleQuestionChange();
        }
    }, [editing]);

    useEffect(() => {
        if (!savedForm) {
            setForms([{form: serviceType.jsa_form}])
        }
    }, [serviceType]);

    const handleQuestionChange = () => {
        let modifiedForm = _.cloneDeep(forms[formIndex].form);
        let sectionIndex = modifiedForm.findIndex(obj => obj.title === editing.section.title);
        if (editing.answer === true) {
            if (editing.delete) {
                let answerIndex = modifiedForm[sectionIndex].answers.findIndex(obj => obj.label === editing.old_value);
                if (answerIndex !== -1) {
                    modifiedForm[sectionIndex].answers.splice(answerIndex, 1);
                }
            } else {
                let answerIndex = modifiedForm[sectionIndex].answers.findIndex(obj => obj.label === editing.old_value);
                if (answerIndex !== -1) {
                    modifiedForm[sectionIndex].answers[answerIndex].label = editing.new_value;
                }
            }
        }
        if (editing.yes_no_section === true) {
            if (editing.delete) {
                let answerIndex = modifiedForm[sectionIndex].yes_no_section.findIndex(obj => obj.label === editing.old_value);
                if (answerIndex !== -1) {
                    modifiedForm[sectionIndex].yes_no_section.splice(answerIndex, 1);
                }
            } else {

                let answerIndex = modifiedForm[sectionIndex].yes_no_section.findIndex(obj => obj.label === editing.old_value);
                if (answerIndex !== -1) {
                    modifiedForm[sectionIndex].yes_no_section[answerIndex].label = editing.new_value;
                }
            }
        }
        if (editing.text_answer === true) {
            if (editing.delete) {
                let answerIndex = modifiedForm[sectionIndex].text_answers.findIndex(obj => obj.label === editing.old_value);
                if (answerIndex !== -1) {
                    modifiedForm[sectionIndex].text_answers.splice(answerIndex, 1);
                }
            } else {
                let answerIndex = modifiedForm[sectionIndex].text_answers.findIndex(obj => obj.label === editing.old_value);
                if (answerIndex !== -1) {
                    modifiedForm[sectionIndex].text_answers[answerIndex].label = editing.new_value;
                }
            }
        }
        if (editing.work_plan === true) {
            if (editing.delete) {
                if (modifiedForm[sectionIndex].work_plan.length > 0) {
                    modifiedForm[sectionIndex].work_plan.pop();
                }
            }
        }
        if (editing.new_answer === true) {
            if (editing.new_answer_type === 'answer') {
                modifiedForm[sectionIndex].answers.push({label: editing.new_value, value: false});
            }
            if (editing.new_answer_type === 'yes_section') {
                modifiedForm[sectionIndex].yes_no_section.push({label: editing.new_value, value: true});
            }
            if (editing.new_answer_type === 'no_section') {
                modifiedForm[sectionIndex].yes_no_section.push({label: editing.new_value, value: false});
            }
            if (editing.new_answer_type === 'text_answer') {
                modifiedForm[sectionIndex].text_answers.push({label: editing.new_value, value: ''});
            }
            if (editing.new_answer_type === 'work_plan') {
                modifiedForm[sectionIndex].work_plan.push({ name: '', task: '' });
            }
        }

        setForms(prevForms =>
            prevForms.map((form, index) =>
                index === formIndex ? { ...form, form: modifiedForm } : form
            )
        );

        setEditing(null);
    };
    const handleCheckboxChange = (value, section, answer) => {

        let modifiedForm = _.cloneDeep(forms[formIndex].form);
        let sectionIndex = modifiedForm.findIndex(obj => obj.title === section.title);
        let answerIndex = modifiedForm[sectionIndex].answers.findIndex(obj => obj.label === answer.label);
        modifiedForm[sectionIndex].answers[answerIndex].value = value;

        setForms(prevForms =>
            prevForms.map((form, index) =>
                index === formIndex ? { ...form, form: modifiedForm } : form
            )
        );
    };
    const handleCheckRadio = (e, section, question) => {

        let modifiedForm = _.cloneDeep(forms[formIndex].form);
        let sectionIndex = modifiedForm.findIndex(obj => obj.title === section.title);
        let questionIndex = modifiedForm[sectionIndex].yes_no_section.findIndex(obj => obj.label === question.label);
        modifiedForm[sectionIndex].yes_no_section[questionIndex].value = e.target.name.includes('_yes');

        setForms(prevForms =>
            prevForms.map((form, index) =>
                index === formIndex ? { ...form, form: modifiedForm } : form
            )
        );
    };
    const handleTextInputChange = (e, section, field) => {
        let modifiedForm = _.cloneDeep(forms[formIndex].form);
        let sectionIndex = modifiedForm.findIndex(obj => obj.title === section.title);
        let fieldIndex = modifiedForm[sectionIndex].text_answers.findIndex(obj => obj.label === field);
        modifiedForm[sectionIndex].text_answers[fieldIndex].value = e.target.value;

        setForms(prevForms =>
            prevForms.map((form, index) =>
                index === formIndex ? { ...form, form: modifiedForm } : form
            )
        );
    };
    const handleWorkInputChange = (e, section, field, index) => {
        let modifiedForm = _.cloneDeep(forms[formIndex].form);
        let sectionIndex = modifiedForm.findIndex(obj => obj.title === section.title);
        modifiedForm[sectionIndex].work_plan[index][field] = e.target.value;

        setForms(prevForms =>
            prevForms.map((form, index) =>
                index === formIndex ? { ...form, form: modifiedForm } : form
            )
        );
    };

    const handleInitialsChange = (e) => {
        let modifiedForm = _.cloneDeep(forms[formIndex].form);
        let sectionIndex = modifiedForm.findIndex(obj => obj.title === 'summary');
        if (sectionIndex !== -1) {
            modifiedForm[sectionIndex].initials = e.target.value;
        } else {
            modifiedForm.push({title: 'summary', initials: e.target.value});
        }

        setForms(prevForms =>
            prevForms.map((form, index) =>
                index === formIndex ? { ...form, form: modifiedForm } : form
            )
        );
    };
    const scrollToBottom = () => {
        setTimeout(() => {
            if (modalScrollRef.current) {
                modalScrollRef.current.scrollTo({
                    top: modalScrollRef.current.scrollHeight,
                    behavior: 'smooth',
                });
            }
        }, 0);
    };
    const handleDateChange = (e, field) => {
        let modifiedForm = _.cloneDeep(forms[formIndex].form);
        let sectionIndex = modifiedForm.findIndex(obj => obj.title === 'summary');

        let parsedDate = null;
        if (typeof e === 'string') {
            parsedDate = moment(e, ['MM/DD/YYYY', defaultDateFormat], true);
            if (!parsedDate.isValid()) return;
        } else {
            parsedDate = e;
        }

        modifiedForm[sectionIndex][field] = parsedDate;

        setForms(prevForms =>
            prevForms.map((form, index) =>
                index === formIndex ? { ...form, form: modifiedForm } : form
            )
        );
    };

    const isValidFill = (forms) => {
        return forms.every(form => {
            const filteredSections = Object.values(form.form).filter(section =>
                section.title === 'summary' || (section.answers?.length > 0) || section.work_plan?.length > 0 || section.text_answers?.length > 0);

            return filteredSections.every(section =>
                section.answers?.some(item => item.value === true) ||
                section.text_answers?.some(item => item.value.length > 0) ||
                section.work_plan?.some(item => item.name.length > 0 && item.task.length > 0) ||
                section.initials?.length > 0
            );
        });
    };

    const getFormattedDate = (date) => {
        return date ? moment(date).format(defaultDateFormat) : '';
    };


    return <Modal
        show={true}
        onHide={onHide}
        bsSize='lg'
        backdrop='static'
        id='questionnaire-modal'
        className='heightAuto fontIOS'
    >
        <Modal.Header>
            <Row>
                <Col xs={6}><h4 className='bold'>JSA/JHA Form - {isEdit ? 'Edit' : forms[formIndex].service_type_name}</h4></Col>
                {isEdit && <Col xs={6} className='d-flex'>
                    <span className='margin-5 content-align-center'>Service Types</span>
                    <Select
                        className="Select width-75"
                        classNamePrefix="select"
                        value={mapForSelect(serviceTypeList).find(option => option.value === selectedService)}
                        options={mapForSelect(serviceTypeList).sort((a, b) => a.label.localeCompare(b.label))}
                        onChange={selectedOption => {
                            setSelectedService(selectedOption.value);
                            onServiceChange(selectedOption.value);
                        }}
                    />
                </Col>}
                {!isEdit && forms.length > 1 && <Col xs={6} className='d-flex justify-flex-end'>
                    <Button className='btn-success add-bigger-margin-right' onClick={handlePrevious} disabled={formIndex === 0}>
                        Previous
                    </Button>
                    <Button className='btn-success' onClick={handleNext} disabled={formIndex === forms.length - 1}>
                        Next
                    </Button>
                </Col>}
            </Row>

        </Modal.Header>
        <Modal.Body className='max-height-600'>
            <div ref={modalScrollRef} className="jsamodal-scroll-container">
            {forms[formIndex]?.form.filter(s => s.title !== 'summary' && (
                (s.answers?.length > 0) ||
                (s.work_plan?.length > 0) ||
                (s.text_answers?.length > 0) ||
                (s.yes_no_section?.length > 0) || isEdit
            )).map(section => {
                return <div>
                    <div className='editable'>
                        <b><span className='mt-2'>{section.title}</span></b>

                        {isEdit && <>
                        <span className='add'
                              onClick={() => setEditing({
                                  section: section,
                                  new_answer: true,
                              })}>Add</span>
                        </>}
                    </div>

                    {section.work_plan.map((wp, index) => {
                        return <span key={index} className='d-flex editable'>
                {index + 1}.{' '}
                            {isEdit ? (
                                '__________/____________________'
                            ) : (
                                <>
                                    <input value={wp.name}
                                           onChange={(e) => handleWorkInputChange(e, section, 'name', index)}/> / <input
                                    value={wp.task}
                                    onChange={(e) => handleWorkInputChange(e, section, 'task', index)}/>
                                </>
                            )}
                            {isEdit &&
                                <span className='delete'
                                      onClick={() => {
                                          setEditing({
                                              section: section,
                                              work_plan: true,
                                              delete: true,
                                          });
                                      }}>Delete</span>
                            }
                            <br/>
            </span>
                    })}
                    {section.answers.map(answer => {
                        return <div className='d-flex editable'>
                            <ColorCheckbox
                                disabled={isEdit}
                                value={isEdit ? false : answer.value}
                                label={`${answer.label}`}
                                onChange={(e) => handleCheckboxChange(e, section, answer)}
                            />
                            {isEdit && <>
                                <span className='edit'
                                      onClick={() => setEditing({
                                          section: section,
                                          answer: true,
                                          old_value: answer.label,
                                          new_value: answer.label,
                                      })}>Edit</span>
                                <span className='delete'
                                      onClick={() => {
                                          setEditing({
                                              section: section,
                                              answer: true,
                                              old_value: answer.label,
                                              new_value: answer.label,
                                              delete: true,
                                          });
                                      }}>Delete</span>
                            </>}
                        </div>;
                    })}
                    {section.text_answers.map(ta => {
                        return <p className='d-flex editable'>{ta.label}
                            {
                                isEdit ? '_'.repeat(20) :
                                    <input value={ta.value}
                                           onChange={(e) => handleTextInputChange(e, section, ta.label)} />}
                            {isEdit && <>
                                <span className='edit'
                                      onClick={() => setEditing({
                                          section: section,
                                          answer: false,
                                          yes_no_section: false,
                                          text_answer: true,
                                          old_value: ta.label,
                                          new_value: ta.label,
                                      })}>Edit</span>
                                <span className='delete'
                                      onClick={() => {
                                          setEditing({
                                              section: section,
                                              answer: false,
                                              yes_no_section: false,
                                              text_answer: true,
                                              old_value: ta.label,
                                              new_value: ta.label,
                                              delete: true,
                                          });
                                      }}>Delete</span>
                            </>}
                        </p>;
                    })}
                    {section.yes_no_section.map(question => {
                        return <div className='yes-no-section'>
                            <div className='mt-2 d-flex editable'>
                                <span>{question.label}</span>
                                {isEdit && <>
                                    <span className='edit'
                                          onClick={() => setEditing({
                                              section: section,
                                              answer: false,
                                              yes_no_section: true,
                                              old_value: question.label,
                                              new_value: question.label,
                                          })}>Edit
                            </span>
                                    <span className='delete'
                                          onClick={() => {
                                              setEditing({
                                                  section: section,
                                                  answer: false,
                                                  yes_no_section: true,
                                                  old_value: question.label,
                                                  new_value: question.label,
                                                  delete: true,
                                              });
                                          }}>Delete</span>
                                </>
                                }
                            </div>
                            <div>
                                <Radio name={`${section.title}${question.label}_yes`}
                                       id={`${section.title}${question.label}_yes`}
                                       disabled={isEdit}
                                       checked={question.value === true}
                                       onChange={(e) => handleCheckRadio(e, section, question)}
                                >
                                    Yes
                                </Radio>
                                <Radio name={`${section.title}${question.label}_no`}
                                       id={`${section.title}${question.label}_no`}
                                       disabled={isEdit}
                                       checked={question.value === false}
                                       onChange={(e) => handleCheckRadio(e, section, question)}
                                >
                                    No
                                </Radio>
                            </div>


                        </div>;
                    })}
                </div>;
            })}
            <b><p>Job Briefing/JHA Initials</p></b>
            <b><p>Initials: {isEdit ? '_'.repeat(30) :
                <input value={forms[formIndex].form.find(s => s.title === 'summary')?.initials} onChange={handleInitialsChange} />}</p>
            </b>
            <b><p>Date(s): {isEdit ? ('_'.repeat(10) + ' ').repeat(3) : <>
                <Row>
                    <Col md={4}>
                        <Datetime
                            dateFormat={defaultDateFormat}
                            isClearable={true}
                            timeFormat={null}
                            value={getFormattedDate(forms[formIndex].form.find(s => s.title === 'summary')?.date)}
                            className='text-center'
                            inputProps={{placeholder: 'Date 1', onFocus: scrollToBottom}}
                            onChange={(e) => handleDateChange(e, 'date')}/>
                    </Col>
                    <Col md={4}>
                        <Datetime
                            dateFormat={defaultDateFormat}
                            isClearable={true}
                            timeFormat={null}
                            value={getFormattedDate(forms[formIndex].form.find(s => s.title === 'summary')?.date1)}
                            className='text-center'
                            inputProps={{placeholder: 'Date 2', onFocus: scrollToBottom}}
                            onChange={(e) => handleDateChange(e, 'date1')}/>
                    </Col>
                    <Col md={4}>
                        <Datetime
                            dateFormat={defaultDateFormat}
                            isClearable={true}
                            timeFormat={null}
                            value={getFormattedDate(forms[formIndex].form.find(s => s.title === 'summary')?.date2)}
                            className='text-center'
                            inputProps={{placeholder: 'Date 3', onFocus: scrollToBottom}}
                            onChange={(e) => handleDateChange(e, 'date2')}/>
                    </Col>
                </Row>


            </>}</p></b>

            </div>
        </Modal.Body>
        <Modal.Footer>
            <Row>
                <Col xs={12}>
                    <Button
                        bsSize='small'
                        bsStyle='warning'
                        onClick={() => onHide()}
                    >
                        Close
                    </Button>
                    <Button
                        bsSize='small'
                        bsStyle='success'
                        disabled={!isEdit && !isValidFill(forms)}
                        onClick={() => {
                            if (isEdit) {
                                serviceType.jsa_form = forms[0].form;
                                onSave(serviceType);
                            } else {
                                onSave(workOrderId, forms, () => {
                                    onReload()
                                });
                            }
                            onHide();
                        }}
                    >
                        Save
                    </Button>
                </Col>
            </Row>
        </Modal.Footer>
        {editing && <Modal show={true}
                           onHide={() => setEditing(false)}
                           bsSize='sm'
                           id='editing-modal'
                           className='heightAuto fontIOS'>

            <Modal.Header>
                {editing.section.title} => {editing.new_answer ? 'New' : `${editing.old_value} - Edit`}
            </Modal.Header>
            <Modal.Body>
                <input value={editing.new_value} className='edit'
                       onChange={(e) => setEditing({...editing, new_value: e.target.value})} />
                {editing.new_answer && answers_type.map(answer => (
                    <Radio
                        key={answer.label}
                        value={answer.value}
                        name={`${answer.label}_radio`}
                        checked={editing.new_answer_type === answer.value}
                        onChange={(e) => e && setEditing({...editing, new_answer_type: answer.value})}
                    >
                        {answer.label}
                    </Radio>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    bsSize='small'
                    bsStyle='warning'
                    onClick={() => setEditing(null)}
                >
                    Cancel
                </Button>
                <Button
                    bsSize='small'
                    bsStyle='success'
                    onClick={handleQuestionChange}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>}
    </Modal>;
};

export default JSAModal;